import React, {Component} from 'react';
import {IntegerField} from '../../../libs/react-components-admin/fields/text-like-field';
import fieldUtils from './field-utils';
import FieldWidth from './field-width';
import ConditionId from './condition-id';

class ParagraphField extends Component {

  constructor(props) {
    super(props);
    this.state = {
      conditions: props.conditions,
      model: props.model,
    };
  }

  static getDerivedStateFromProps(nextProps) {
    return {conditions: nextProps.conditions};
  }

  updateModel(fieldName, value) {
    this.setState(
      prevState => {
        const model = {...prevState.model};
        model[fieldName] = value;
        return {model};
      },
      () => this.props.onChange(this.state.model)
    );
  }

  parseInteger(v) {
    return v == null || v === '' ? null : parseInt(v, 10);
  }

  render() {
    return <div className="row">
      <div className="col-12">
        <div className="mb-3">
          <label htmlFor="paragraph" className="form-label">Text</label>
          <textarea id="paragraph" name="paragraph"
                    className="form-control"
                    style={{minHeight: '120px'}}
                    value={this.state.model.text}
                    onChange={e => this.updateModel('text', e.target.value)}/>
        </div>
      </div>
      <div className="col-12">
        <FieldWidth value={this.state.model.widthInPercent}
                    onChange={v => this.updateModel('widthInPercent', v)}/>
      </div>
      <div className="col-12 col-md-6">
        <div className="mb-3">
          <label htmlFor="alignment" className="form-label">Alignment</label>
          <select id="alignment" name="alignment"
                  className="form-select"
                  value={this.state.model.alignment || ''}
                  onChange={e => this.updateModel('alignment', e.target.value)}>
            <option key={0} value={''}/>
            {fieldUtils.alignments.map((width, i) => {
              return <option key={i + 1} value={width.value}>{width.label}</option>
            })}
          </select>
          <div className="form-text">Leave blank to use your theme defaults</div>
        </div>
      </div>
      <div className="col-12 col-md-6">
        <IntegerField id="fontSize"
                      label="Font size in pixels"
                      value={this.state.model.fontSizeInPx}
                      onChange={v => this.updateModel('fontSizeInPx', v)}/>
      </div>
      <div className="col-12 col-md-6">
        <IntegerField id="marginTop"
                      label="Top margin in pixels"
                      helpBlock="Leave blank to use your theme defaults"
                      value={this.state.model.marginTop}
                      onChange={v => this.updateModel('marginTop', v)}/>
      </div>
      <div className="col-12 col-md-6">
        <IntegerField id="marginBottom"
                      label="Bottom margin in pixels"
                      helpBlock="Leave blank to use your theme defaults"
                      value={this.state.model.marginBottom}
                      onChange={v => this.updateModel('marginBottom', v)}/>
      </div>
      <div className="col-12">
        <ConditionId id={this.props.id}
                     conditions={this.state.conditions}
                     value={this.state.model.conditionId}
                     onChange={v => this.updateModel('conditionId', v)}/>
      </div>
    </div>
  }

}

export default ParagraphField;